import AccountSpinnerPage from './AccountSpinner';

export default AccountSpinnerPage;
